import { render, staticRenderFns } from "./CustOverview.vue?vue&type=template&id=11fcadd5&scoped=true"
import script from "./CustOverview.vue?vue&type=script&lang=js"
export * from "./CustOverview.vue?vue&type=script&lang=js"
import style0 from "./CustOverview.vue?vue&type=style&index=0&id=11fcadd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcadd5",
  null
  
)

export default component.exports